import React from "react";
import { connect } from "react-redux";
import DatosForm from "./datos.frm.js";

const mapState = (state) => {
	return {
		email: state.registroAF.email,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		siguientePaso: () => {
			dispatch({ "type": "REGISTRO_FAMILIAR_PASO", "paso": 1 });
		},
		registrarDatos(sEmail, oDatosForm) {
			dispatch({
				"type": "REGISTRO_FAMILIAR_DATOS",
				"apaterno": oDatosForm.apaterno,
				"amaterno": oDatosForm.amaterno,
				"nombres": oDatosForm.nombres,
				"email": sEmail,
				"fechaNacimiento": oDatosForm.fecha_nacimiento,
				"fechaNacimientoDate": oDatosForm.fecha_nacimiento_date,
				"genero": oDatosForm.genero,
				"ladaCelular": oDatosForm.telefono_movil.substr(0, 2),
				"telCelular": oDatosForm.telefono_movil.substr(2, 10),
				"rfc": oDatosForm.rfc,
				"poliza": oDatosForm.poliza
			});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class Datos extends React.Component {

	submit = (data) => {
		console.log('data', data);
		localStorage.setItem("lada_movil", data.telefono_movil.substr(0, 2));
		localStorage.setItem("telefono_movil", data.telefono_movil.substr(2, 10));
		this.props.loader(true);
		return new Promise((resolve) => {
			
			this.props.tagManager({ "type": "EVENT_ACCESOFAMILIAR_DATOS-SIG-CORRECTOS", "dispositivo": this.props.dispositivo });
			this.props.registrarDatos(this.props.email, data);

			setTimeout(() => {
				this.props.loader(false);
				this.props.siguientePaso();
			}, 2000);
			resolve();
		});
	}

	render() {
		return <DatosForm onSubmit={this.submit} />;
	}
}

export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/gnp-registro-familiar/datos.cmpt.js